module.exports = __webpack_public_path__ + "img/mobile/Background/background_portraitv2@1x.jpg?0.0.53";